<template>
  <b-container fluid>
    <!-- User Interface controls -->
    <b-row>
      <b-col lg="6" class="my-1">
        <h5>Listado de tus pólizas vigentes</h5>
        <p>Puedes usar el cuadro de búsqueda para localizar una póliza</p>
      </b-col>

      <b-col lg="6" class="my-1">
        <b-form-group
          label="Búsqueda"
          label-for="filter-input"
          label-cols-sm="3"
          label-align-sm="right"
          label-size="sm"
          class="mb-0"
        >
          <b-input-group size="sm">
            <b-form-input
              id="filter-input"
              v-model="filter"
              type="search"
              placeholder="Escribe palabra que quieras buscar"
            ></b-form-input>
          </b-input-group>
        </b-form-group>
      </b-col>
    </b-row>
    <!-- Main table element -->
    <b-table
      :items="items"
      :fields="fields"
      :current-page="currentPage"
      :per-page="perPage"
      :filter="filter"
      :filter-included-fields="filterOn"
      :sort-by.sync="sortBy"
      :sort-desc.sync="sortDesc"
      :sort-direction="sortDirection"
      :sort-compare="nestedSortCompare"
      stacked="md"
      show-empty
      small
      @filtered="onFiltered"
      empty-text=""
    >
      <template #cell(name)="row">
        {{ row.value.first }} {{ row.value.last }}
      </template>

      <template #cell(actions)="row">
        <router-link
          v-if="verRecibos"
          :to="{ name: 'Mis Recibos', params: { id: row.item.id } }"
        >
          <b-button class="mr-1" size="sm" variant="success">
            <i class="fa fa-search"></i> Recibos
          </b-button>
        </router-link>
        <br />

        <router-link
          :to="{ name: 'Gestión de Siniestros', params: { id: row.item.id } }"
        >
          <b-button class="mr-1" size="sm" variant="success">
            <i class="fa fa-search"></i> Siniestros
          </b-button>
        </router-link>
        &nbsp;&nbsp;
        <b-button
          @click="showNewClaim(row.item)"
          class="mr-1"
          size="sm"
          variant="danger"
        >
          <i class="fa fa-file"></i> Nuevo siniestro
        </b-button>
        <br />
      </template>
    </b-table>
    <center>
      <moon-loader
        :loading="loadingTable"
        color="green"
        size="80px"
      ></moon-loader>
      <br />
    </center>
    <b-row>
      <b-col sm="12" md="12" class="my-1">
        <b-pagination
          v-model="currentPage"
          :total-rows="totalRows"
          :per-page="perPage"
          align="fill"
          size="sm"
          class="my-0"
          first-text="Primera"
          prev-text="Anterior"
          next-text="Siguiente"
          last-text="Última"
        ></b-pagination>
      </b-col>
    </b-row>
    <b-modal
      hide-footer
      size="xl"
      id="file-manager"
      ref="file-manager"
      :title="tituloEmailClaimSelected(policySelected)"
    >
      <template v-slot:modal-header-close>
        <i class="fa fa-close"></i>
      </template>
      <NuevoSiniestro :claim="policySelected"></NuevoSiniestro>
    </b-modal>
  </b-container>
</template>

<script>
import NuevoSiniestro from "@/components/Siniestros/NuevoSiniestro";
import { policyService } from "@/src/../_services";
import moment from "moment";
import MoonLoader from "vue-spinner/src/MoonLoader.vue";
import { userService } from "@/src/../_services";
export default {
  name: "MisPolizasColaborador",
  components: {
    MoonLoader: MoonLoader,
    NuevoSiniestro,
  },
  data() {
    return {
      verRecibos: false,
      loadingTable: true,
      policies: [],
      items: [],
      policySelected: {},
      fields: [
        {
          key: "numero_poliza",
          label: "Póliza",
          sortable: true,
          sortDirection: "desc",
        },
        {
          key: "cliente",
          label: "Cliente",
          sortable: true,
          class: "text-center",
        },
        {
          key: "compania",
          label: "Compañía",
          sortable: true,
          class: "text-center",
        },
        { key: "ramo", label: "Ramo", sortable: true, class: "text-center" },
        {
          key: "fecha_efecto",
          label: "Fecha de efecto",
          sortable: true,
          class: "text-center",

        },
        { key: "actions", label: "Opciones" },
      ],
      totalRows: 1,
      currentPage: 1,
      perPage: 7,
      pageOptions: [5, 10, 15, { value: 100, text: "Ver todo" }],
      sortBy: "",
      sortDesc: false,
      sortDirection: "asc",
      filter: null,
      filterOn: [],
      infoModal: {
        id: "info-modal",
        title: "",
        content: "",
      },
    };
  },
  computed: {
    sortOptions() {
      // Create an options list from our fields
      return this.fields
        .filter((f) => f.sortable)
        .map((f) => {
          return { text: f.label, value: f.key };
        });
    },
  },
  async mounted() {
    // Comprobar si el usuario peude ver información de recibos
    //const myGroups = JSON.parse(localStorage.getItem('groups'));
    this.verRecibos = false;
    // Set the initial number of items
    this.totalRows = this.items.length;
    this.misPolizas = await policyService.getPolicies();
    //console.log(`listado de polizas: ${JSON.stringify( this.misPolizas )}`)
    if (this.misPolizas["error"] !== undefined) {
      //console.log("No está autenticado")
      switch (this.misPolizas["error"].response.status) {
        case 401:
          // La sesión ha caducado. A la página de login
          //console.log(`Error: ${this.misPolizas["error"].response.status}`)
          this.$router.push('login');
          break;
        default:
          //console.log(`Error: ${this.misPolizas["error"].response.status}`)
          break;
      }
    }
    else {
      this.items = policyService.getPoliciesTable(this.misPolizas);
      this.totalRows = this.items.length;
    }
    this.loadingTable = false;
  },
  methods: {
    sorterByDat(a, b) {
      var aa = moment(a, "DD/MM/YYYY");
      var bb = moment(b, "DD/MM/YYYY");
      return aa < bb;
    },
    showNewClaim(claim) {
      // We pass the ID of the button that we want to return focus to
      // when the modal has hidden
      this.policySelected = claim;
      this.$refs["file-manager"].show();
    },
    tituloEmailClaimSelected(claimSelected) {
      return `Siniestro nuevo para la póliza ${this.policySelected.numero_poliza} (${this.policySelected.compania}) del cliente ${this.policySelected.cliente}`;
    },
    nestedSortCompare(valOne, valTwo, key) {
      //console.log('comparando campos')
      switch (key) {
        case "fecha_efecto":
          return moment(valOne.fecha_efecto, "DD/MM/YYYY") < moment(valTwo.fecha_efecto, "DD/MM/YYYY");
        default:
          return null;
      }
    },
    onFiltered(filteredItems) {
      // Trigger pagination to update the number of buttons/pages due to filtering
      this.totalRows = filteredItems.length;
      this.currentPage = 1;
    },
  },
};
</script>
<style>
.table {
  font-size: 0.8em !important;
  font-weight: 300;
}

.page-item.active .page-link {
  z-index: 3;
  color: #fff;
  background-color: #8fd19e !important;
  border-color: #8fd19e !important;
}

.page-link {
  position: relative;
  display: block;
  padding: 0.5rem 0.75rem;
  margin-left: -1px;
  line-height: 1.25;
  color: #1e4827 !important;
  background-color: #fff;
  border: 1px solid #dee2e6;
}

.b-form-input {
  border-left: 1px solid !important;
  border-right: 1px solid !important;
}
</style>
